import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const communicationsStatusPageDetailsRoute: InvariantJiraRoute = {
	name: 'communications-status-page-details',
	path: '/jira/communications/status-page/:pageId',
};
